import { useTranslation } from "react-i18next";
import type { MetricId } from "./metrics";

export const useMetricLabel = () => {
  const { t } = useTranslation("portal");

  const metricLabel = (metricId: MetricId): string => {
    switch (metricId) {
      case "weight":
        return t("Weight");
      case "calories":
        return t("Calories");
      case "protein":
        return t("Protein");
      case "carbs":
        return t("Carbs");
      case "fat":
        return t("Fat");
      case "fiber":
        return t("Fiber");
      case "water":
        return t("Water");
    }
  };

  return { metricLabel };
};
